/* eslint-disable max-len */
import * as React from 'react';

const AddIcon = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.3334 19.3333C11.3334 19.7016 11.6319 20.0001 12.0001 20.0001C12.3682 20.0001 12.6667 19.7016 12.6667 19.3334V12.6666H19.3333C19.7015 12.6666 20 12.3681 20 12C20 11.6318 19.7015 11.3333 19.3333 11.3333H12.6667V4.66667C12.6667 4.29848 12.3682 4 12.0001 4C11.6319 4 11.3334 4.29847 11.3334 4.66667V11.3333H4.66667C4.29848 11.3333 4 11.6318 4 12C4 12.3681 4.29848 12.6666 4.66667 12.6666H11.3334V19.3333Z"
      fill="#FBFAFA"
    />
  </svg>
);
export default AddIcon;
